import { createApp } from 'vue';
import MkvToMp3Converter from '@/Components/MkvToMp3Converter.vue';
import '@styles/app.css';

createApp(MkvToMp3Converter).mount('#mkv-to-mp3-converter');
